import Theme from 'styles/theme';

const breakpoints = {
  small: { min: Theme.get('breakpoint-small-min'), max: Theme.get('breakpoint-small-max') },
  medium: {
    min: Theme.get('breakpoint-medium-min'),
    max: Theme.get('breakpoint-medium-max'),
  },
  large: {
    min: Theme.get('breakpoint-large-min'),
    max: Theme.get('breakpoint-large-max'),
  },
  extraLarge: {
    min: Theme.get('breakpoint-extra-large-min'),
    max: Theme.get('breakpoint-extra-large-max'),
  },
};
const small = `only screen and (max-width: ${breakpoints.small.max}px)`;
const smallUp = `only screen and (min-width: ${breakpoints.small.min}px)`;
const medium = `only screen and (min-width: ${breakpoints.medium.min}px) and (max-width: ${breakpoints.medium.max}px)`;
const mediumUp = `only screen and (min-width: ${breakpoints.medium.min}px)`;
const large = `only screen and (min-width: ${breakpoints.large.min}px) and (max-width: ${breakpoints.large.max}px)`;
const largeUp = `only screen and (min-width: ${breakpoints.large.min}px)`;
const extraLarge = `only screen and (min-width: ${breakpoints.extraLarge.min}px)`;
const landscape = 'only screen and (orientation: landscape)';
const portrait = 'only screen and (orientation: portrait)';
const retina = `
  only screen and (-webkit-min-device-pixel-ratio: 2),
  only screen and (min--moz-device-pixel-ratio: 2),
  only screen and (-o-min-device-pixel-ratio: 2/1),
  only screen and (min-device-pixel-ratio: 2),
  only screen and (min-resolution: 192dpi),
  only screen and (min-resolution: 2dppx)
`;
const ie10AndAbove = `all and (-ms-high-contrast: none), (-ms-high-contrast: active)`;

export {
  breakpoints,
  small,
  smallUp,
  medium,
  mediumUp,
  large,
  largeUp,
  extraLarge,
  landscape,
  portrait,
  retina,
  ie10AndAbove,
};
